{
    "webshop_offer_voucher_correctCode": "輸入的代碼正確",
    "webShop_howToFindId_desc": "You can find and copy your personal ID in your player profile.",
    "webShop_howToFindId_link": "Where do I find my personal ID?",
    "webshop_offer_voucher_codeIsIncorrect": "代碼不正確",
    "webshop_offer_voucher_enterYourCode": "輸入你的代碼",
    "webShop_unexpectedError_desc": "An unexpected error occurred, please try again later.",
    "webShop_accountBanned_desc": "Account banned!",
    "webshop_confirm": "好",
    "webshop_offer_voucher_welcome_title": "Welcome, {{playername}}",
    "webshop_continue": "Continue"
}
